<app-dialog-container
  title="{{ 'sendNotifications' | translate }}"
  (confirmButtonHandler)="submit()"
  confirmButtonText="{{ 'confirm' | translate }}"
>
  <form>
    <app-ui-select
      [label]="'users' | translate"
      [control]="userIds"
      [options]="users"
      [isMultiple]="true"
    ></app-ui-select>
  </form>
</app-dialog-container>
